import { render, staticRenderFns } from "./DataTrainer.vue?vue&type=template&id=32969a09&scoped=true&"
import script from "./DataTrainer.vue?vue&type=script&lang=js&"
export * from "./DataTrainer.vue?vue&type=script&lang=js&"
import style0 from "./DataTrainer.vue?vue&type=style&index=0&id=32969a09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32969a09",
  null
  
)

export default component.exports